interface IHumanizeOptions {
  capitalize?: boolean;
  keepIdSuffix?: boolean;
}

/**
 * Capitalizes the first letter of a string, as well as replacing any
 * underscores or dashes with spaces. Useful for converting enum-like values to
 * human-readable strings. Note that this function is a port of Rails'
 * [humanize](https://apidock.com/rails/String/humanize). The big difference is
 * this port does not handle acronyms.
 *
 * @param str The string afflicted with snake or kebab case and utter lack of
 * respect for proper capitalization.
 * @param capitalize Whether to capitalize the first letter of the string.
 * Defaults to true.
 * @param keepIdSuffix Whether to keep the `_id` suffix of the string. Defaults
 * to false.
 * @returns The proud, happy string, now with spaces and a right proper capital
 * first letter.
 */
export const humanize = (
  str: string | null | undefined,
  { capitalize = true, keepIdSuffix = false }: IHumanizeOptions = {},
): string => {
  if (!str) {
    return '';
  }
  const desuffixed = keepIdSuffix ? str : str.replace(/_id$/, '');
  const spaced = desuffixed.replace(/[-_]/g, ' ').trim();
  const capitalized = capitalize
    ? spaced[0].toUpperCase() + spaced.slice(1)
    : spaced;
  return capitalized;
};
